// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../queries/fragments.generated';
export type ReadyPlanLikeButtonMenu_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } };

export type ReadyPlanLikeButtonMenu_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } };

export type ReadyPlanLikeButtonMenu_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } };

export type ReadyPlanLikeButtonMenu_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } };

export type ReadyPlanLikeButtonMenuFragment =
  | ReadyPlanLikeButtonMenu_ReadyPlan_Fragment
  | ReadyPlanLikeButtonMenu_PlanPackage_Fragment
  | ReadyPlanLikeButtonMenu_DesignPackage_Fragment
  | ReadyPlanLikeButtonMenu_ProductOffering_Fragment
;

export type ReadyPlanLikeButtonMenuAggregateDraftFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc = gql`
    fragment ReadyPlanLikeButtonMenuAggregateDraft on ReadyPlanAggregateVersion {
  id
  displayVersion
  canDelete {
    ...PotentialOperationDetails
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const ReadyPlanLikeButtonMenuFragmentDoc = gql`
    fragment ReadyPlanLikeButtonMenu on ReadyPlanLike {
  ...Named
  aggregateLatest {
    id
  }
  aggregateDraft {
    ...ReadyPlanLikeButtonMenuAggregateDraft
  }
  canEdit {
    ...PotentialOperationDetails
  }
  status {
    code
  }
}
    ${NamedFragmentDoc}
${ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;